/**
 * Shows team + stream membership for a prospect (`project_prospect`-style object) with navigation chips.
 *
 * Where: `LeadOverview` / `TeamsStreamsList`.
 * Uses: MUI `Chip`/`Typography` only.
 * Behavior: optional `onOpenTeam` / `onOpenStream` chip clicks.
 */
import React from 'react';
import {
  Box,
  Typography,
  Chip,
} from '@mui/material';
import { CheckCircle as CheckCircleIcon } from '@mui/icons-material';

interface TeamStreamPreviewCardProps {
  teamProspect: any;
  onOpenTeam?: (teamUuid: string) => void;
  onOpenStream?: (streamUuid: string) => void;
}

export const TeamStreamPreviewCard: React.FC<TeamStreamPreviewCardProps> = ({ 
  teamProspect,
  onOpenTeam,
  onOpenStream,
}) => {
  return (
    <Box sx={{ p: 1.5, border: 1, borderColor: 'divider', borderRadius: 1 }}>
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center', mb: 1 }}>
        {teamProspect.team?.key && onOpenTeam && (
          <Chip size="small" label={teamProspect.team.name} onClick={() => onOpenTeam(teamProspect.team.key)} />
        )}
        {teamProspect.stream?.key && onOpenStream && (
          <Chip size="small" label={teamProspect.stream.name} onClick={() => onOpenStream(teamProspect.stream.key)} />
        )}
        {teamProspect.connection_degree && <Chip size="small" label={`Conn: ${teamProspect.connection_degree}`} />}
        {teamProspect.has_paper && <Chip size="small" label="Paper" color="success" />}
        {teamProspect.has_patent && <Chip size="small" label="Patent" color="success" />}
        {teamProspect.added_to_campaign && <Chip size="small" icon={<CheckCircleIcon />} label="Added to Campaign" color="info" />}
        {teamProspect.post_filtered && <Chip size="small" label="Post-filtered" />}
        {teamProspect.location_filtered && <Chip size="small" label="Location-filtered" />}
      </Box>
      {teamProspect.brief && (
        <Typography variant="body2" sx={{ mb: 1 }}>
          <strong>Brief:</strong> {teamProspect.brief.length > 300 ? teamProspect.brief.slice(0, 300) + '…' : teamProspect.brief}
        </Typography>
      )}
      {teamProspect.application && (
        <Typography variant="body2" color="text.secondary">
          <strong>Application:</strong> {teamProspect.application.length > 300 ? teamProspect.application.slice(0, 300) + '…' : teamProspect.application}
        </Typography>
      )}
    </Box>
  );
};
